import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Stack, Icon, Chip, Tooltip, Typography } from 'investira.react.components';

const AvalicoesSaveStatus = memo(props => {
  return (
    <Stack direction="row" gap={2} alignItems="center">
      <Typography variant="caption" color="textSecondary">
        Última atualização: 12/02/2026 14:30
      </Typography>
      <Tooltip title={'Atualizado em 16/02/2026 às 14:32'}>
        <span>
          <Chip label="Rascunho" color="warning" sx={{ px: 1 }} size="small" variant="contained" />
        </span>
      </Tooltip>
    </Stack>
  );
});

AvalicoesSaveStatus.propTypes = {};

export default AvalicoesSaveStatus;
